module.exports = __webpack_public_path__ + "1f9f5f5e34d279c86bc68e3f88abf7ed.svg";